import api from "../api";
import {
 TRANSLATE,
  GET_ALL_TRANSLATED_PAGES,
  UPDATE_TRANSLATED_PAGE,
  DELETE_TRANSLATE_PAGE,
  GET_ERRORS,
  GET_PAGE_BY_ID

} from "./types";


export const translatedpages = () => (dispatch) => {
  return api
    .get("/api/translations/translatedpages")
    .then((res) => {
      dispatch({
        type: GET_ALL_TRANSLATED_PAGES,
        payload: res.data.data , // depends on your API shape
      });
      return res; // optional
    })
    .catch((err) => {
      dispatch({
        type: GET_ERRORS,
        payload: err.response?.data || err.message,
      });
      throw err; // so .catch/.finally in component still works
    });
};



export const translatepage = ({ pageId, siteId, targetLanguage }) => (dispatch) => {

  return api
    .post(
      `/api/translations/translate/${pageId}`,
      {
        targetLanguage,
        siteid: siteId, // backend expects `siteid` in body
      }
    )
    .then((res) => {
     dispatch({
        type:TRANSLATE,
        payload: pageId, // 👈 the _id of the deleted page
      });
      return res; // optional

    })
    .catch((err) => {
      dispatch({
        type: GET_ERRORS,
        payload: err.response?.data || err.message,
      });
      throw err;
    });
};

export const deletetrans = (id) => (dispatch) => {
  return api
    .delete(`/api/translations/transpages/${id}`)
    .then(() => {
      dispatch({
        type: DELETE_TRANSLATE_PAGE,
        payload: id, // 👈 the _id of the deleted page
      });
    })
    .catch((err) => {
      dispatch({
        type: GET_ERRORS,
        payload: err.response?.data || err.message,
      });
      throw err;
    });
};

export const updateTranslatedPage = ({ id, updates }) => (dispatch) => {
  return api
    .patch(`/api/translations/translated-pages/${id}`, updates)
    .then((res) => {
      dispatch({
        type: UPDATE_TRANSLATED_PAGE,
        payload: res.data.data, // The updated page data
      });
      return res;
    })
    .catch((err) => {
      dispatch({
        type: GET_ERRORS,
        payload: err.response?.data || err.message,
      });
      throw err;
    });
};



export const transpagebyid = (id) => (dispatch) => {
  return api
    .get(`/api/translations/translated-pages/${id}`)
    .then((res) => {
      dispatch({
        type: GET_PAGE_BY_ID,
        payload: res.data.data , // depends on your API shape
      });
      return res; // optional
    })
    .catch((err) => {
      dispatch({
        type: GET_ERRORS,
        payload: err.response?.data || err.message,
      });
      throw err; // so .catch/.finally in component still works
    });
};
